import VideoModalContainer from './VideoModalContainer';

export default VideoModalContainer;
